// Analyses search routes
export default [
  {
    path: 'analyses-search',
    name: 'analysesSearch',
    component: () =>
      import(
        /* webpackChunkName: "analysesSearch" */ '../views/analysesSearch/AnalysesSearch.vue'
      ),
    meta: {
      tabbable: true,
      tableKeys: [],
      filterKeys: [],
      formKeys: ['analysesSearch'],
      routePermissions: ['searchManage'],
    },
  },
];
